import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Virtual Care Concerns',
    field: 'virtualCareConcerns',
    type: 'info',
    subLabel: `Virtual Care has some inherent privacy and security risks that your health information may be intercepted or unintentionally disclosed. We want to make sure you understand this before we proceed. In order to improve privacy and confidentiality, you should also take steps to participate in Virtual Care in a private setting, use an encrypted email service if available, and you should not use an employer’s or someone else’s computer/device as they may be able to access your information. If it is determined you require a physical exam you may still need to be assessed in person. You should also understand that virtual care is not a substitute for attending the Emergency Department if urgent care is needed. If you continue, you consent to the use of electronic communication to provide you with care, are you ok to continue?`,
    answer: {
      type: 'consent-check',
      label: 'I agree.',
      name: 'virtualCareConcernsConsent',
      required: true
    }
  }
];
export default questionsModels;
